import React from "react";
import "animate.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

export function Footer(props) {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    if (location.pathname === "/") {
      // If already on the home page, just scroll smoothly
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to home first, then scroll after navigation
      navigate("/", { replace: false });
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Small delay to ensure navigation happens first
    }
  };

  return (
    <>
      <footer className="bg-[#333] text-white py-12">
        <div className="container mx-auto grid md:grid-cols-4 gap-8">
          <div className="pl-8">
            <h4 className="text-xl font-bold mb-4">About SlumSoccer</h4>
            <p>Empowering children & youth through sports.</p>
          </div>
          <div>
            <h4 className="text-xl font-bold mb-4 pl-8">Quick Links</h4>
            <ul className="space-y-2 pl-8">
              <li>
                <Link to="/" className="hover:text-[#FF6600]">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/projects" className="hover:text-[#FF6600]">
                  Projects
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("impact")}
                  className="hover:text-[#FF6600]"
                >
                  Impact
                </button>
              </li>
              <li>
                <Link to="/career" className="hover:text-[#FF6600]">
                  Career
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#FF6600]">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-xl font-bold mb-4 pl-8">Policies</h4>
            <ul className="space-y-2 pl-8">
              <li>
                <Link
                  to="/poshpolicy"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="hover:text-[#FF6600]"
                >
                  POSH Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/csppolicy"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="hover:text-[#FF6600]"
                >
                  Child Safeguarding and Protection Policy
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-xl font-bold mb-4 pl-8">Contact Us</h4>
            <div className="pl-8">
              <span>Email: </span>
              <a
                href="mailto:reachus@slumsoccer.org"
                className="text-white hover:text-[#FF6600]"
              >
                reachus@slumsoccer.org
              </a>
            </div>

            <div className="pl-8">
              <span>Phone: </span>
              <a
                href="tel:+917122556865"
                className="text-white hover:text-[#FF6600]"
              >
                +91 7122556865
              </a>
            </div>

            <br />
            <div className="flex space-x-4 mt-4 pl-8">
              <a
                href="https://www.facebook.com/SlumSoccer/"
                className="text-white hover:text-[#FF6600]"
              >
                Facebook
              </a>
              <a
                href="https://www.instagram.com/slumsoccer/"
                className="text-white hover:text-[#FF6600]"
              >
                Instagram
              </a>
              <a
                href="https://x.com/slumsoccer?s=21&t=v2VY8-xqWL9D-yRJ3UTQ8w"
                className="text-white hover:text-[#FF6600]"
              >
                X
              </a>
              <a
                href="https://www.threads.com/@slumsoccer?igshid=NTc4MTIwNjQ2YQ=="
                className="text-white hover:text-[#FF6600]"
              >
                Threads
              </a>
            </div>
            <div className="flex space-x-4 mt-1">
              <a
                href="https://www.linkedin.com/company/slum-soccer/"
                className="text-white hover:text-[#FF6600] pl-8"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        <div className="text-center mt-8 border-t border-gray-700 pt-4">
          &copy; 2025 Slum Soccer. All Rights Reserved.
        </div>
      </footer>
    </>
  );
}
